module.exports = __webpack_public_path__ + "img/精致与实用本不矛盾.453c3607.png";